import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect } from 'react';
import { pluginKey } from '../../pm-plugins/plugin-key';
import { useRefreshWidthOnTransition } from './useRefreshOnTransition';
export var setEditorWidth = function setEditorWidth(props) {
  return function (editorView) {
    var dispatch = editorView.dispatch,
      tr = editorView.state.tr;
    tr.setMeta(pluginKey, props);
    dispatch(tr);
  };
};

/**
 * Tracks the current width of the editor and its container in plugin state for plugins to listen to
 *
 * @param editorView EditorView - used to get the DOM element and dispatch transactions
 * @param containerElement HMTLElement - the container of the editor used to measure the current width
 */
export function useResizeWidthObserver(_ref) {
  var editorView = _ref.editorView,
    containerElement = _ref.containerElement;
  useRefreshWidthOnTransition(containerElement);
  useEffect(function () {
    var resizeWidth = function resizeWidth(entries) {
      var _fullAreaSize$borderB, _editorViewDOMSize$bo;
      if (entries.length < 1) {
        return;
      }
      var fullAreaSize = entries.find(function (entry) {
        return entry.target === containerElement;
      });
      var editorViewDOMSize = entries.find(function (entry) {
        return entry.target === editorView.dom;
      });
      var width = fullAreaSize === null || fullAreaSize === void 0 || (_fullAreaSize$borderB = fullAreaSize.borderBoxSize[0]) === null || _fullAreaSize$borderB === void 0 ? void 0 : _fullAreaSize$borderB.inlineSize;
      var lineLength = editorViewDOMSize === null || editorViewDOMSize === void 0 || (_editorViewDOMSize$bo = editorViewDOMSize.borderBoxSize[0]) === null || _editorViewDOMSize$bo === void 0 ? void 0 : _editorViewDOMSize$bo.inlineSize;
      setEditorWidth({
        width: width,
        lineLength: lineLength
      })(editorView);
    };
    var resizeObserver = new ResizeObserver(resizeWidth);
    if (containerElement) {
      resizeObserver.observe(containerElement);
    }
    if (editorView.dom) {
      resizeObserver.observe(editorView.dom);
    }
    return function () {
      resizeObserver.disconnect();
    };
  }, [containerElement, editorView]);
}
export var useResizeWidthObserverLegacy = function useResizeWidthObserverLegacy(_ref2) {
  var editorView = _ref2.editorView,
    containerElement = _ref2.containerElement;
  useRefreshWidthOnTransition(containerElement);
  useEffect(function () {
    var newState = {
      lineLength: editorView.dom.clientWidth,
      width: containerElement === null || containerElement === void 0 ? void 0 : containerElement.offsetWidth
    };
    setEditorWidth(newState)(editorView);
  }, [editorView, editorView.dom.clientWidth, containerElement]);
  useEffect(function () {
    var resizeWidth = function resizeWidth(entries) {
      if (entries.length !== 1) {
        return;
      }
      var _entries = _slicedToArray(entries, 1),
        fullAreaSize = _entries[0];
      if (!fullAreaSize || !Array.isArray(fullAreaSize.borderBoxSize)) {
        return;
      }
      var width = fullAreaSize.borderBoxSize[0].inlineSize;
      var lineLength = editorView.dom.clientWidth;
      setEditorWidth({
        width: width,
        lineLength: lineLength
      })(editorView);
    };
    var resizeObserver = new ResizeObserver(resizeWidth);
    if (containerElement) {
      resizeObserver.observe(containerElement);
    }
    return function () {
      resizeObserver.disconnect();
    };
  }, [containerElement, editorView]);
};